<template>
  <div class="container-fluid">
    <page-title
      :canDownload="false"
      :title="this.$t('support.email')"
      iconClasses="fas fa-envelope"
      :isTimelineDisplayed="false"
      :isDataLoading="isLoading"
    ></page-title>

    <div class="container-fluid controls">
      <div class="form-group row justify-content-md-center">
        <!--<label
          for="inputEmail"
          :class="isSmallScreen ? 'col-sm-6 col-form-label' : 'col-auto col-form-label'"
          >{{ $t('search.email') }}</label
        >-->
        <div :class="'col-sm-6'">
          <input
            type="text"
            id="inputEmail"
            class="form-control"
            v-model.trim="search"
            @input="downloaded = false"
            @keyup.enter="fetchEmails"
            :placeholder="$t('search.email')"
          />
        </div>
      </div>
    </div>

    <br />

    <div class="container">
      <p
        v-if="
          supportEmailDataset.results.length > 0 &&
            supportEmailDataset.email.trim() !== '' &&
            downloaded
        "
      >
        {{ $t('support.email_found', [totalSessions, supportEmailDataset.email.trim()]) }}
        <button
          type="button"
          class="btn btn-primary"
          data-toggle="modal"
          data-target="#sendingConfirmationModal"
        >
          <i class="fas fa-envelope"></i>
        </button>
      </p>
      <p v-if="supportEmailDataset.results.length === 0 && downloaded">
        {{ $t('support.no_email_found') }}<strong>{{ search }}</strong>
      </p>
    </div>

    <!-- Modal use to confirm mail after visit sending -->
    <div
      class="modal fade"
      id="sendingConfirmationModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sendingConfirmationModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="sendingConfirmationModalLabel">
              {{ $t('modal.confirm_sending_mail', [search]) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              {{ $t('cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              data-dismiss="modal"
              @click="sendMailAfterVisit"
            >
              {{ $t('confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { utilsMixin, sitesMixin } from '../utils/mixins'

export default {
  name: 'EmailSupport',
  dependencies: ['dataService'],
  mixins: [utilsMixin, sitesMixin],
  data() {
    return {
      downloaded: false,
      isLoading: false,
      supportEmailDataset: { email: '', results: [] },
      search: this.$route.params.email ? this.$route.params.email : '',
      buckets: [
        { id: 5, name: 'imagerie_epinal' },
        { id: 6, name: 'palais_des_papes' },
      ],
      startDate:
        this.$route.params.start != undefined
          ? new Date(this.$route.params.start)
          : moment().subtract(1, 'month'),
      endDate:
        this.$route.params.end != undefined
          ? new Date(this.$route.params.end)
          : moment(new Date(), 'YYYY-MM-DD'),
      indexToSend: -1,
      selectedResult: {},
      sendingOK: false,
      sendingNOK: false,
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
    setTimeout(() => {
      this.fetchEmails()
    }, 300)
  },
  components: {
    'page-title': () => import('./utils/PageTitle'),
  },
  computed: {
    oldLogs: function() {
      const sessionTime = moment(this.selectedResult.session_time, 'DD/MM/YYYY').unix()
      const breakTime = moment('13/07/2018', 'DD/MM/YYYY').unix()
      return sessionTime < breakTime
    },
    totalSessions: function() {
      return this.supportEmailDataset.results.reduce(
        (acc, currentValue) => acc + currentValue.sessions.length,
        0,
      )
    },
  },
  methods: {
    fetchEmails: function() {
      if (this.search.trim().length > 0) {
        window.history.pushState(null, null, '/support/email/' + this.search)
        this.isLoading = true

        this.dataService
          .getSupportForEmail(this.search)
          .then(result => {
            this.supportEmailDataset = result
            this.downloaded = true
            this.isLoading = false
          })
          .catch(e => {
            console.error('Error', e)
            this.isLoading = false
            this.downloaded = false
          })
      }
    },
    sendMailAfterVisit: async function() {
      if (
        this.supportEmailDataset.email.trim() !== '' &&
        this.supportEmailDataset.results.length > 0
      ) {
        try {
          this.isLoading = true
          await this.dataService.resendEmailAfterVisit(
            this.supportEmailDataset.email,
            this.supportEmailDataset.results[0].sessions.map(session => session.session_id),
          )
          this.$toasted.show(
            this.$t('support.send_confirmation', [this.supportEmailDataset.email]),
            {
              theme: 'toasted-primary',
              position: 'bottom-center',
              duration: 4000,
            },
          )
        } catch (error) {
          console.error('sendMailAfterVisit error', error)
          this.$toasted.show(this.$t('support.send_error', [error.message]), {
            theme: 'toasted-error',
            position: 'bottom-center',
            duration: 4000,
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style>
.starter-template {
  padding: 3rem 1.5rem;
  text-align: center;
}

.table > tbody > tr > td {
  vertical-align: middle;
}

.table > tbody > tr > th {
  vertical-align: middle;
}
</style>
